import React, { useContext } from 'react'
import { NewSiteTabItem, NewSiteTabWrapper } from 'flow/siteProposal/components/tabs/style'
import { FormattedMessage } from 'react-intl'
import { MonitoringContext } from 'providers/monitoring'

const MonitoringTabs = ({ changeTab, active }) => {
  const { monitoring } = useContext(MonitoringContext)

  const stateEnabled = !!monitoring && monitoring.state_evaluation === true
  const pressureEnabled = !!monitoring && monitoring.pressure_evaluation === true
  const responseEnabled = !!monitoring && monitoring.response_evaluation === true

  return (
    <NewSiteTabWrapper onClick={changeTab} data-test="monitoring-tabs">
      <NewSiteTabItem isActive={active === 'details'} id="details">
        <FormattedMessage id="siteDetails" />
      </NewSiteTabItem>
      <NewSiteTabItem isActive={active === 'about'} id="about">
        <FormattedMessage id="about" />
      </NewSiteTabItem>
      <NewSiteTabItem isActive={active === 'state'} id="state" disabled={!stateEnabled}>
        <FormattedMessage id="state" />
      </NewSiteTabItem>
      <NewSiteTabItem isActive={active === 'pressure'} id="pressure" disabled={!pressureEnabled}>
        <FormattedMessage id="pressure" />
      </NewSiteTabItem>
      <NewSiteTabItem isActive={active === 'response'} id="response" disabled={!responseEnabled}>
        <FormattedMessage id="response" />
      </NewSiteTabItem>
      <NewSiteTabItem isActive={active === 'overview'} id="overview">
        <FormattedMessage id="dashboard" />
      </NewSiteTabItem>
      <NewSiteTabItem isActive={active === 'guidanceandtools'} id="guidanceandtools">
        <FormattedMessage id="guidanceandtools" />
      </NewSiteTabItem>
    </NewSiteTabWrapper>
  )
}

export default MonitoringTabs
